<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="hasLabelViewPermission">
        <button *ngIf="!isViewMode" mat-icon-button [matMenuTriggerFor]="labelsMenu">
          <i class="angularjs-fuse-icon icon-label-outline"></i>
        </button>

        <mat-menu #labelsMenu="matMenu" [overlapTrigger]="false">
          <label-selector
            [quotationId]="quotation.id"
            [associatedLabels]="quotation.labels"
            (wasUpdatedLabels)="wasUpdatedLabels()"
            type="quotation"
          >
          </label-selector>
        </mat-menu>
      </div>

      <h2 class="field-dialog__header__title">{{ quotation.identifier }} - {{ quotation.location?.name }}</h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab label="{{ 'QUOTATIONS.GENERAL' | translate }}">
      <disclaimer *ngIf="isViewMode" [message]="'QUOTATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-general [quotation]="quotation" [isViewMode]="isViewMode"></tab-general>
    </mat-tab>

    <mat-tab *ngIf="quotation?.id" label="{{ 'QUOTATIONS.ATTACHMENTS.TITLE_HEADER' | translate }}">
      <disclaimer *ngIf="isViewMode" [message]="'QUOTATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-quotation-attachments [quotationId]="quotation.id"></tab-quotation-attachments>
    </mat-tab>
  </mat-tab-group>

  <div
    class="field-dialog__footer"
    fxLayout="row"
    [fxLayoutAlign]="
      !isViewMode && quotation.status === 'pending' && hasFeatureApproveQuotationByPanel
        ? 'space-between center'
        : 'end center'
    "
  >
    <div
      *ngIf="!isViewMode && quotation.status === 'pending' && hasFeatureApproveQuotationByPanel"
      class="quotation-buttons"
    >
      <button
        data-cy="dialog-quotation-approve-button"
        class="field-background"
        [disabled]="fuseProgressBarService.visible | async"
        mat-raised-button
        (click)="executeAction('approve')"
      >
        {{ 'QUOTATIONS.APPROVE' | translate }}
      </button>
      <button
        data-cy="dialog-quotation-refuse-button"
        color="warn"
        [disabled]="fuseProgressBarService.visible | async"
        mat-raised-button
        (click)="executeAction('refuse')"
      >
        {{ 'QUOTATIONS.REJECT' | translate }}
      </button>
    </div>

    <a
      [href]="reportUrl + quotation.id"
      target="_blank"
      mat-icon-button
      rel="noreferrer noopener"
      matTooltip="{{ 'MAINTENANCES.REPORT' | translate }}"
    >
      <i class="angularjs-fuse-icon icon-clipboard-text"></i>
    </a>
  </div>
</div>
